// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// require("bootstrap")
// require("leaflet") // per le mappe


import 'bootstrap'
require("js_files/sb_admin_pro")
require("js_files/toast")
require("js_files/banana-translations")
require("js_files/for-eternity")
require("js_files/charts")


window.jQuery = $;
window.$ = $;

require('datatables.net-bs4')

require("trix")
require("@rails/actiontext")


import 'leaflet/dist/leaflet.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css'; // Re-uses images from ~leaflet package
import * as L from 'leaflet';
import 'leaflet-defaulticon-compatibility';

import * as esri from 'esri-leaflet'
import * as geocoder from 'esri-leaflet-geocoder'
L.esri = esri
L.esri.Controls = geocoder
require("js_files/leaflet")

require("js_files/modals")

// require('esri-leaflet')
// require('esri-leaflet-geocoder')

import '../stylesheets/application'


// require('imports-loader?define=>false!datatables.net')(window, $)
// require('imports-loader?define=>false!datatables.net-bs4')(window, $)

// require( 'datatables.net-dt' )(window, $);

// require( 'datatables.net-bs4' )(jQuery);
// require('imports-loader?define=>false!datatables.net-bs4')(window, $)

document.addEventListener("turbolinks:load", () => {
  require("js_files/tagsinput")

})


// require("js_files/datetimepickers")
import {initMyDatetimePickers} from 'js_files/datetimepickers';
window.initMyDatetimePickers = initMyDatetimePickers;


var formVal = require("js_files/formValidation/FormValidation")
window.FormValidation = formVal
FormValidation.plugins.Bootstrap = require("js_files/formValidation/plugins/Bootstrap")
// FormValidation.plugins.AutoFocus = require("js_files/formValidation/plugins/AutoFocus")
FormValidation.locales.en_US = require("js_files/formValidation/locales/en_US")


require("js_files/events")
require("js_files/macro_events")


document.addEventListener("turbolinks:load", () => {
  $('.spinner-on-btn').on('click', function() {
    var $el = $(this).find('.spinner-border')
    $el.removeClass('d-none')
  })

  // prettify event_specifications JSON content
  // var el = document.getElementById('event_specifications')
  // if (el) {
  //   var s1 = el.innerHTML
  //   var s2 = s1.replaceAll("\"=&gt;", "\": ")
  //   var json = JSON.parse(s2);
  //   var s3 = JSON.stringify(json, undefined, 4);

  //   // display pretty printed object in text area:
  //   el.innerHTML = s3;
  // }




  $('.copy-to-clipboard').on('click', async function(event) {
    var url = $(this).data('url');
    await navigator.clipboard.writeText(url);
    $('body').attr('data-flash', '{"notice": "File link copied!"}')
    throw_flash()
  })

  // Inside trix-content
  // always open links in a new tab
  $('.trix-content a').attr('target', '_blank');



  var disable_button = () => {
    if ($('#event_files').val()=="") {
      $('#event_files_btn').prop('disabled', true);
    } else {
      $('#event_files_btn').prop('disabled', false);
    }
  }
  $('#event_files').on('change', () => {
    disable_button()
  })
  disable_button()
})
